import { render, staticRenderFns } from "./left-top.vue?vue&type=template&id=892ed1da&"
import script from "./left-top.vue?vue&type=script&lang=js&"
export * from "./left-top.vue?vue&type=script&lang=js&"
import style0 from "./left-top.vue?vue&type=style&index=0&id=892ed1da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports